import uuidv4 from 'uuid/v4'

export const randomUuid = () => {
    return uuidv4()
}

export const parseUrl = (url) => {
    if (url?.startsWith('/') !== -1) {
        return `${process.env.VUE_APP_API_URL}${url}`
    }
    return url
}

export const numToPriceText = (num) => {
    const num2 = (Math.round(num * 100) / 100).toFixed(2);
    const parts = num2.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}


export const mergeChildrenAll = (page, options = { ignores: [], }) => {
    if (page) {
        if (page.data) {
            for (let i = 0; i < page.data.length; ++i) {
                const d = page.data[i];
                const keys = Object.keys(d)
                for (let j = 0; j < keys.length; ++j) {
                    const key = keys[j];
                    if (!options.ignores.includes(key)) {
                        mergeChildrenAll(d[key]);
                        if (d[key] && d[key].data) {
                            d[key] = d[key].data;
                        }
                    }
                }
            }
        } else if (page instanceof Object && !(page instanceof Array)) {
            const keys = Object.keys(page)
            for (let i = 0; i < keys.length; ++i) {
                const key = keys[i];
                if (!options.ignores.includes(key)) {
                    mergeChildrenAll(page[key]);
                    if (page[key] && page[key].data) {
                        page[key] = page[key].data;
                    }
                }
            }
        }
    }
}